export default {

    CURRENT_USER_KEY:'currentUser',
    SIGN_UP_INFO:'signUpInfo',

    saveUserSession: function(userObject){
        localStorage.setItem(this.CURRENT_USER_KEY, JSON.stringify(userObject));
    },

    removeUserSession: function(){
        localStorage.removeItem(this.CURRENT_USER_KEY);
    },

    getUserSession: function(){
        let user = localStorage.getItem(this.CURRENT_USER_KEY);
        return  user == "undefined" ?  undefined : user ;
    },
    
    getSignupInfo: function () {
        return JSON.parse(localStorage.getItem(this.SIGN_UP_INFO));
    },

    setSignupInfo: function (signUpInfo) {
        let user = localStorage.setItem(this.SIGN_UP_INFO, JSON.stringify(signUpInfo));
    },

    resetSignupInfo: function (signUpInfo) {
        let user = localStorage.removeItem(this.SIGN_UP_INFO);
    }
}